exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".appointment-heading h4{margin-bottom:10px;padding:0 5px;font-size:20px;font-weight:700}.appointment-text>p{font-size:1rem;font-weight:500;line-height:19px;color:#4c4c4c}.appointment-text>p:nth-child(2){font-size:.875rem}.sub-text{padding-top:2px;font-weight:500}.icon-container{display:flex;height:36px;width:36px;margin-bottom:5px;align-items:center;justify-content:center;border-radius:50%}.icon-container svg{width:24px;height:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/Appointment/ScheduleForm.scss
// module id = 8117
// module chunks = 13